var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5182 8.248V6.976C6.9502 6.95467 7.28087 6.864 7.5102 6.704C7.74487 6.53867 7.8622 6.296 7.8622 5.976V5.864C7.8622 5.61867 7.78754 5.42933 7.6382 5.296C7.48887 5.15733 7.28887 5.088 7.0382 5.088C6.77154 5.088 6.5582 5.16533 6.3982 5.32C6.2382 5.47467 6.12887 5.672 6.0702 5.912L5.3102 5.608C5.3582 5.44267 5.42754 5.28267 5.5182 5.128C5.6142 4.97333 5.7342 4.83733 5.8782 4.72C6.0222 4.59733 6.19287 4.50133 6.3902 4.432C6.58754 4.35733 6.8142 4.32 7.0702 4.32C7.33154 4.32 7.56887 4.35733 7.7822 4.432C7.99554 4.50667 8.17687 4.61333 8.3262 4.752C8.47554 4.88533 8.5902 5.05067 8.6702 5.248C8.7502 5.44 8.7902 5.65333 8.7902 5.888C8.7902 6.128 8.74754 6.344 8.6622 6.536C8.5822 6.72267 8.47287 6.88267 8.3342 7.016C8.20087 7.14933 8.04887 7.25867 7.8782 7.344C7.70754 7.424 7.53154 7.48 7.3502 7.512V8.248H6.5182ZM6.9422 10.096C6.73954 10.096 6.5902 10.048 6.4942 9.952C6.40354 9.85067 6.3582 9.72267 6.3582 9.568V9.432C6.3582 9.27733 6.40354 9.152 6.4942 9.056C6.5902 8.95467 6.73954 8.904 6.9422 8.904C7.14487 8.904 7.29154 8.95467 7.3822 9.056C7.4782 9.152 7.5262 9.27733 7.5262 9.432V9.568C7.5262 9.72267 7.4782 9.85067 7.3822 9.952C7.29154 10.048 7.14487 10.096 6.9422 10.096Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTooltipIcon);
export default __webpack_public_path__ + "static/media/planTooltipIcon.876b9ecc2df41b0d3c6d183f39024a8a.svg";
export { ForwardRef as ReactComponent };